<div class="d-flex flex-column">
    <div class="text-container">
        {{ displayedText }}
    </div>
    @if (showMoreLessButton) {
        <eff-button
            class="link-button"
            [text]="isMore ? 'Read less' : 'Read more'"
            (onClick)="onMoreClick()"
        ></eff-button>
    }
</div>
